window.initCarousel = function () {
    let $carousel = $('.ec-carousel');

    $(".next").on("click", {d: "n"}, rotate);
    $(".prev").on("click", {d: "p"}, rotate);

    function rotate(e) {
        let direction = e.data.d;
        let $items = $('.ec-item', $carousel);
        let $item = null;

        for (let i = 0; i < $items.length; i++) {
            $item = $($items[i]);

            let idx = $item.data('idx');
            let newIdx = direction === 'p' ? (idx < $items.length ? idx + 1 : 1) : (idx > 1 ? idx - 1 : $items.length);

            $item
                .removeClass(`ec-item--${idx}`)
                .addClass(`ec-item--${newIdx}`)
                .data('idx', newIdx);
        }

        $item = $('.ec-item--1', $carousel);

        let id = $item.data('character-id');

        $('.ec-js-character-sheet:not(".hidden")').fadeOut(100);

        $('.ec-js-character-sheet:nth-child({i})'.replace('{i}', id)).fadeIn(300);
    }


    let hammer = new Hammer($('.ec-carousel')[0]);

    hammer.on('swipeleft', function () {
        rotate({data: {d: 'n'}});
    });

    hammer.on('swiperight', function () {
        rotate({data: {d: 'p'}});
    });
};